import { render, staticRenderFns } from "./CaseFrom.vue?vue&type=template&id=7cc4ac0e&scoped=true"
import script from "./CaseFrom.vue?vue&type=script&lang=js"
export * from "./CaseFrom.vue?vue&type=script&lang=js"
import style0 from "./CaseFrom.vue?vue&type=style&index=0&id=7cc4ac0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc4ac0e",
  null
  
)

export default component.exports